import React, { Component } from 'react'
import {connect} from "react-redux"
import {storePackages} from "../../actions/storeActions"
import Package from "./package"
import ButtonLoader from '../btnloader';

class Packagelist extends Component {

    componentDidMount(){
        this.props.storePackages(this.props.is_recharge);
    }

    render() {
        let {history, is_recharge} = this.props;
        let key = is_recharge ? "recharge" : "packages";
        return (
            <div className="row">
                {
                    this.props[key].fetching ? 
                        <div className="flex-center" style={{height: `300px`}}>
                            <ButtonLoader />
                        </div> 
                    : this.props[key].data  ? 
                    this.props[key].data.map((pack) => 
                        <Package history={history} {...pack} key={pack.id}/>
                    ) : null
                }
            </div>
        )
    }
}

const mapStateToProps = ({storePackages, storeRecharge}) => ({
    packages: storePackages,
    recharge: storeRecharge
})

const mapDispatchToProps = {
    storePackages
}

const TopupList = connect(mapStateToProps, mapDispatchToProps)(Packagelist);

export default TopupList
